/**
 * IMPORTANT - BLOCKCHAIN DATA INTEGRITY:
 * This file handles blockchain data which must maintain exact values and case sensitivity.
 * - NEVER use toLowerCase() or toUpperCase()
 * - NEVER normalize strings or addresses
 * - NEVER transform collection names
 * - NEVER modify contract addresses
 * - ALWAYS use exact matches for comparisons
 * - ALWAYS preserve original data as it exists on-chain
 */

// API Endpoints
export const API_ENDPOINTS = {
    NFTFI: {
        COLLECTIONS: 'https://theta-sdk-api.nftfi.com/data/v0/pipes/loans_due_by_collection_endpoint.json',
        LOANS: 'https://theta-sdk-api.nftfi.com/data/v0/pipes/loans_due_endpoint.json'
    },
    RESERVOIR: {
        COLLECTIONS: '/api/reservoir/collections/v7',
        TOKENS: '/api/reservoir/tokens/v6',
        ATTRIBUTES: 'https://api.reservoir.tools/collections/{id}/attributes/all/v2'
    },
    PRICEFLOOR: {
        CHARTS: 'https://api.nftpricefloor.com/api/projects/{slug}/charts/1d'
    },
    LOANS: '/api/nftfi/data/v0/pipes/loans_due_endpoint.json',
};

// Cache Configuration
export const CACHE_CONFIG = {
    VERSION: '1.0',
    DURATION: 5 * 60 * 1000 // 5 minutes
};

// Rate Limiting Configuration
export const RATE_LIMIT = {
    maxRetries: 3,          // Maximum number of retries
    initialDelay: 1000,     // 1 second initial delay
    maxDelay: 10000,        // 10 seconds max delay
    batchSize: 2,           // Only 2 tokens per batch
    batchDelay: 2000,       // 2 seconds between batches
    concurrentLimit: 2,     // Only 2 requests at a time
    jitterFactor: 0.3       // Add 30% random jitter to delays
}; 